import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { getNewsById } from '../../mockData';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function NewsDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  
  // 获取当前语言
  const currentLang = i18n.language || 'zh';
  
  // 获取新闻详情
  const newsItem = getNewsById(Number(id), currentLang);
  
  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;
  
  // 如果找不到新闻，显示错误信息
  if (!newsItem) {
    return (
      <div className="news-detail-container">
        <div 
          className="news-detail-cloud-bg"
          style={{
            backgroundImage: `url(${cloudBgUrl})`
          }}
        />
        <div className="news-detail-section-container">
          <div className="news-detail-error">
            <h2>{t('newsDetail.notFound')}</h2>
            <button 
              className="news-detail-back-button"
              onClick={() => navigate('/news')}
            >
              {t('newsDetail.backToList')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-detail-container">
      <div 
        className="news-detail-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="news-detail-section-container">
        <div className="news-detail-content">
          <div className="news-detail-header">
            <h1 className="news-detail-article-title">
              {newsItem.title}
            </h1>
            <p className="news-detail-date">{newsItem.date}</p>
          </div>
          
          <div className="news-detail-body">
            <div className="news-detail-description">
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                components={{
                  a: ({ node, ...props }) => {
                    const href = props.href || '';
                    const isExternal = /^https?:\/\//i.test(href);
                    const rawClass = props.className;
                    const classStr = Array.isArray(rawClass) ? rawClass.join(' ') : (rawClass || '');
                    const noIcon = classStr.includes('no-icon');
                    const showIcon = classStr.includes('show-icon');
                    const shouldShowIcon = noIcon ? false : (showIcon || isExternal);
                    const linkClassName = ['news-detail-markdown-link', rawClass].filter(Boolean).flat().join(' ');
                    return (
                      <a
                        {...props}
                        className={linkClassName}
                        target={isExternal ? '_blank' : undefined}
                        rel={isExternal ? 'noopener noreferrer' : undefined}
                      >
                        {props.children}
                        {shouldShowIcon && (
                          <img
                            src={`${process.env.PUBLIC_URL}/image/跳转.png`}
                            alt="jump"
                            className="news-detail-link-icon"
                          />
                        )}
                      </a>
                    );
                  },
                }}
              >
                {newsItem.content || newsItem.description}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsDetail;

